import { Card } from '../../../../components/ui/card';
import { Printer, ChevronDown, ChevronUp } from 'lucide-react';
import { usePrinterWebSocket } from '../../../../hooks/usePrinterWebSocket';
import { usePrinters } from '../../../../hooks/usePrinters';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

export function PrinterStatus() {
  const navigate = useNavigate();
  const { status, clientStatus, foundPrinters } = usePrinterWebSocket();
  const { printers, loading } = usePrinters();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    console.log('🖨️ PrinterStatus - Estado actualizado:', {
      status,
      clientStatus,
      printersCount: printers?.length,
      loading,
      component: 'PrinterStatus',
      timestamp: new Date().toISOString()
    });
  }, [status, clientStatus, printers, loading]);

  const getStatusColor = () => {
    if (loading) return 'bg-gray-300 dark:bg-gray-600';
    if (!printers.length) return 'bg-gray-300 dark:bg-gray-600';
    if (status === 'connected' && clientStatus === 'running') return 'bg-green-500';
    if (status === 'connected' && clientStatus === 'stopped') return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const getStatusText = () => {
    if (loading) return 'Cargando...';
    if (!printers.length) return 'Sin configurar';
    if (status === 'connected' && clientStatus === 'running') return 'Conectada';
    if (status === 'connected' && clientStatus === 'stopped') return 'Servicio detenido';
    return 'Desconectada';
  };

  const getStatusIcon = () => {
    const color = getStatusColor().replace('bg-', 'text-');
    return <Printer className={`h-5 w-5 ${color}`} />;
  };

  return (
    <Card className={`transition-all duration-200 ${isExpanded ? 'p-4' : 'p-2'}`}>
      <div className="space-y-4">
        <div 
          className="flex items-center justify-between cursor-pointer"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="flex items-center gap-2">
            {getStatusIcon()}
            {isExpanded && <h2 className="text-lg font-semibold">Estado Impresora</h2>}
          </div>
          <div className="flex items-center gap-2">
            {!isExpanded && (
              <>
                <div className={`w-2 h-2 rounded-full ${getStatusColor()}`} />
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  {printers.filter(p => p.status === 'online').length}/{printers.length}
                </span>
              </>
            )}
            {isExpanded ? (
              <>
                <span className="text-sm text-gray-600 dark:text-gray-400">{getStatusText()}</span>
                <ChevronUp className="h-4 w-4 text-gray-500" />
              </>
            ) : (
              <ChevronDown className="h-4 w-4 text-gray-500" />
            )}
          </div>
        </div>

        {/* Contenido expandible */}
        {isExpanded && (
          <>
            {!printers.length ? (
              <div className="flex justify-end">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/settings/printers');
                  }}
                  className="text-sm text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300"
                >
                  Configurar impresora
                </button>
              </div>
            ) : (
              <div className="space-y-2">
                <div className="text-sm text-gray-500 dark:text-gray-400">Impresoras configuradas:</div>
                <div className="space-y-2">
                  {[...printers]
                    .sort((a, b) => {
                      if (a.status === 'online' && b.status !== 'online') return -1;
                      if (a.status !== 'online' && b.status === 'online') return 1;
                      return 0;
                    })
                    .map((printer) => (
                      <div 
                        key={printer.id}
                        className="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-700 rounded-md"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <span className="text-sm font-medium">{printer.name || printer.ip_address}</span>
                        <span className={`px-2 py-0.5 rounded-full text-xs ${
                          printer.status === 'online' 
                            ? 'bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-400' 
                            : 'bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-400'
                        }`}>
                          {printer.status === 'online' ? 'Conectada' : 'Desconectada'}
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Card>
  );
} 